import { render, staticRenderFns } from "./manualRecord.vue?vue&type=template&id=94038b2e"
import script from "./manualRecord.vue?vue&type=script&lang=js"
export * from "./manualRecord.vue?vue&type=script&lang=js"
import style0 from "./manualRecord.vue?vue&type=style&index=0&id=94038b2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports